<template>
    <v-lazy v-model="active" :min-height="50" :options="{ 'threshold': 0.1 }" transition="fade-transition">
        <v-card v-if="loading" elevation="0">
          <v-skeleton-loader type="list-item-avatar, list-item, list-item, divider">
          </v-skeleton-loader>
        </v-card>
        <v-alert v-else-if="!loading && error" type="error">Failed to load job {{ jobId }}</v-alert>
        <JobListItem v-else :jobItem="JobData" :show-status="true" previewMode>
        </JobListItem>
    </v-lazy>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import JobListItem from "@/components/ListItems/JobListItem/JobListItem.vue";

export default {
    name: 'LazyJobListItem',
    props: {
        jobId: Number,
    },
    components: {
        JobListItem,
    },
    mixins: [clientAPI],

    data() {
        return {
            active: false,
            loading: true,
            error: false,
        };
    },

    mounted() {
        this.getJob();
    },

    methods: {
        async getJob() {
            this.loading = true;
            await this.getJobById(this.jobId, true)
                .then((response) => {
                    this.error = false;
                    this.JobData = response;
                })
                .catch((/*error*/) => {
                    this.error = true;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },

    computed: {},

    watch: {
        active: function () {
            this.getJob();
        },
    },
};
</script>


<style lang='scss' scoped></style>